export default __webpack_public_path__ + "static/media/Businessman-amico.8ebca4ab.svg";